import { bicyclePedestrianDetailsComponent } from './bicycle-pedestrian-details.component';

export const bicyclePedestrianDetails = angular
    .module('components.bicyclePedestrian.bicyclePedestrianDetails', [])
    .component('bicyclePedestrianDetails', bicyclePedestrianDetailsComponent)
    // .config(($stateProvider) => {
    //     'ngInject';

    //     $stateProvider
    //         .state('app.dashboard.bicyclePedestrianDetails', {
    //             breadcrumbName: 'Details',
    //             parentState: 'app.dashboard.BicycleAndPedestrian',
    //             url: '/transportation-information/bicycle-pedestrian/:id/details',
    //             component: 'bicyclePedestrianDetails',
    //             resolve: {
    //                 details($stateParams, TransportationAlternativeService) {
    //                     '$ngInject';

    //                     return TransportationAlternativeService.getBicyclePedestrianDetailsById($stateParams.id);
    //                 }
    //             }
    //         });
    // })
    .name;


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/bicycle-pedestrian/bicycle-pedestrian-details/bicycle-pedestrian-details.module.js